import defaultSettings from '@/settings'

const title = defaultSettings.title || '重庆方奥软件开发有限公司'

export default function getPageTitle (pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js